import React from 'react';
import { Typography, Fade, Stack, Box, CircularProgress } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Lottie from 'react-lottie';
import animationProcessing from '../images/animation_processing.json';
import { TEXT_PRIMARY, TEXT_SECONDARY, TEXT_TERTIARY, ACCENT, STATUS_WON, noMotion } from './tokens';

const processing = {
  loop: true,
  autoplay: true,
  animationData: animationProcessing,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice"
  }
};

const ProcessingComponent = ({ processingText, steps }) => {
  const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  return (
    <Fade in={true} style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <Stack
        spacing={2}
        alignItems="center"
        justifyContent="center"
      >
        <Lottie
          options={processing}
          height="125px"
          width="125px"
          isPaused={prefersReducedMotion}
        />
        <Typography
          data-testid="processing-text"
          variant="h5"
          gutterBottom
          align="center"
          sx={{ color: TEXT_PRIMARY }}
        >
          {processingText}
        </Typography>
        {/* Multi-stage progress list */}
        {steps && steps.length > 0 && (
          <Stack spacing={1} alignItems="center">
            {steps.map((step) => (
              <Box
                key={step.key}
                data-testid={`processing-step-${step.key}`}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                  py: 0.5,
                  transition: 'opacity 200ms ease-out',
                  ...noMotion,
                }}
              >
                {step.done ? (
                  <CheckCircleIcon sx={{ fontSize: 18, color: STATUS_WON }} />
                ) : step.active ? (
                  <CircularProgress size={16} sx={{ color: ACCENT }} />
                ) : (
                  <Box sx={{ width: 18, height: 18, borderRadius: '50%', border: '1.5px solid', borderColor: TEXT_TERTIARY }} />
                )}
                <Typography
                  variant="body2"
                  sx={{
                    color: step.done ? STATUS_WON : step.active ? TEXT_PRIMARY : TEXT_TERTIARY,
                    fontWeight: step.active ? 500 : 400,
                    fontSize: '0.85rem',
                  }}
                >
                  {step.label}
                </Typography>
              </Box>
            ))}
          </Stack>
        )}
      </Stack>
    </Fade>
  );
};

export default ProcessingComponent;
